import _ from 'lodash';
import { log } from '@swiper/core';
import { Service } from './Service';

export class EventsService extends Service {

  get name() { return 'events'; }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
};
